import { Box, Button } from '@mui/material'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
import { useState } from 'react'

import { GeoJsonMapDialog } from '../../Components'

interface Props {
  quadkey: Quadkey
}

const MapButton: React.FC<Props> = (props) => {
  const { quadkey } = props
  const [dialogOpen, setDialogOpen] = useState(false)

  const onClick = () => {
    setDialogOpen(!dialogOpen)
  }

  return (
    <Box>
      <Button onClick={onClick} variant="outlined">
        Map
      </Button>
      <GeoJsonMapDialog
        quadkey={quadkey}
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false)
        }}
      />
    </Box>
  )
}

export default MapButton
